//描述：错别字校对
//作者：fanglijuan
//时间：2017-03-01
"use strict";
angular.module("markContentHeimaCompareModule", [])
    .directive("markContentHeima", ["$timeout", "heimaCheckService", "ueditorService", "$compile",
        function($timeout, heimaCheckService, ueditorService, $compile) {
            return {
                scope: {
                    checkFinish: "=",
                    finishCallback: "&",
                    className: "@",
                    fontSpacing: "=", //预设字体和行距等，配合APP渠道
                    isClearColor: "=" //微信渠道，不清除颜色效果
                },
                restrict: 'AE',
                template: '<div class="contentHeimaWordLeft {{className}}">' +
                    '<div class="contentHeimaWordLeftBorder">' +
                    '<div class="contentHeimaWordHeader scroll-fix-active" trs-scroll-fix="" enable-fix="true" fix-top="47" fix-relative-element="[list=\'list\']" fix-box-element=".creation-pos-el">' +
                    '<div class="clear"></div>' +
                    '<div class="contentHeimaWordLevel">' +
                    '<span class="contentHeimaWordLevel_tit" ng-bind="subHeimaWordsArr.length==0?\'没有发现错误信息\':\'错误信息（建议替换）：\'"></span>' +
                    '<ul>' +
                    '<li ng-repeat="heimaWord in subHeimaWordsArr" ng-bind="heimaWord"></li>' +
                    '</ul>' +
                    '</div>' +
                    '<div class="clear"></div>' +
                    '</div>' +
                    '<div class="TRS_heima_ueditor"></div>' +
                    '</div>' +
                    '</div>',
                transclude: true,
                replace: true,
                link: function($scope, $element, iAttrs, controller) {
                    var ue;
                    var otherAreaState; //其他区域初始状态的保存，在关闭敏感词校验的时候恢复原状
                    initBoundary();
                    initData();
                    initToolBarHeight();
                    initboundaryHeight();
                    /**
                     * [markHeimaWord description]根据黑马和黑马级别来标记htmlcontent
                     * @param  {[string]} htmlContent [description]html正文
                     * @param  {[array]} heimaWordsArr [description]黑马数组
                     * @return {[string]}  htmlContent    [description]标记完成的htmlcontent
                     */
                    LazyLoad.css('./components/util/ueditor/service/css/ueditorBuiltInStyles.css?v=2.0');

                    function markHeimaWord(htmlContent) {
                        if (htmlContent !== "") {
                            heimaCheckService.getHeimaWordOfContent().then(function(heimaWordsArr) {
                                $scope.heimaWordsArr = heimaWordsArr;
                                $scope.subHeimaWordsArr = [];
                                /*$scope.subHeimaWordsArrToStr = [];*/
                                //构造标红元素
                                htmlContent = heimaCheckService.markHeimaWord(htmlContent, heimaWordsArr, function(value) {
                                    $scope.subHeimaWordsArr = value;
                                });
                                /*heimaCheckService.dealWithHeimaWordsArr($scope.subHeimaWordsArr).then(function(data) {
                                    $scope.subHeimaWordsArrToStr = data;
                                });*/
                                //htmlContent = heimaCheckService.markHeimaWord(htmlContent, heimaWordsArr);

                                htmlContent = $compile(htmlContent)($scope);
                                $(".TRS_heima_ueditor").html(htmlContent);
                            });
                        } else {
                            $scope.heimaWordsArr = [];
                            $scope.subHeimaWordsArr = [];
                            $(".TRS_heima_ueditor").html("");
                        }
                    }

                    function initData() {
                        ue = UE.getEditor('ueditor');
                        var htmlcontent = ue.getContent();
                        htmlcontent = ueditorService.replaceHtmlBlank(htmlcontent);
                        if ($scope.isClearColor == undefined) {
                            htmlcontent = clearColor(htmlcontent);
                        }
                        markHeimaWord(htmlcontent);
                        ue.fireEvent('contentchange'); //防止编辑器展开高度不够
                    }

                    //初始化工具条高度
                    function initToolBarHeight() {
                        var height;
                        var myInterval = setInterval(function() {
                            if ($(".edui-editor-toolbarbox").html() !== undefined) {
                                height = $(".edui-editor-toolbarbox").height();
                                $(".contentHeimaWordHeader").height(height);
                                $(".edui-editor-toolbarbox").resize(function() {
                                    height = $(this).height();
                                    $(".contentHeimaWordHeader").height(height);
                                });
                                clearInterval(myInterval);
                                return;
                            }
                        }, 10);
                        var promiseChange;
                        $scope.$watch("enterFixArea", function(newVale, oldValue) {
                            var parentHeight = $(".contentHeimaWordLeftBorder").height();
                            var marginTop = (newVale === true ? (height - 15) : 0) + "px";
                            if (angular.isDefined($scope.fontSpacing))
                                $(".TRS_heima_ueditor").css("cssText", "font-family:" + $scope.fontSpacing.fontType + "!important;font-size:" + $scope.fontSpacing.fontSize + "!important;line-height:" + $scope.fontSpacing.lineSpacing + "em!important");
                            $(".TRS_heima_ueditor").css("margin-top", marginTop);
                        });
                    }
                    //初始化整体界面高度
                    function initboundaryHeight() {
                        var height;
                        var myInterval_ = setInterval(function() {
                            if ($(".edui-editor").html() !== undefined) {
                                height = $(".edui-editor").height();
                                $(".contentHeimaWordLeftBorder").height(height);
                                $(".edui-editor").resize(function() {
                                    height = $(this).height();
                                    $(".contentHeimaWordLeftBorder").height(height);
                                });
                                clearInterval(myInterval_);
                                return;
                            }
                        }, 10);
                    }
                    /**
                     * [clearColor description]处理正文中的背景（白色）以及字体颜色（黑色）
                     * @param  {[type]} htmlcontent [description]
                     * @return {[type]}             [description]
                     */
                    function clearColor(htmlcontent) {
                        if (htmlcontent !== "") {
                            var reg1 = /background-color[\s:]+[^;]*/g;
                            var reg2 = /color[\s:]+[^;]*/g;
                            htmlcontent = htmlcontent.replace(reg2, "color:black").replace(reg1, "background-color:white");
                        }
                        return htmlcontent;
                    }

                    function initBoundary() {
                        otherAreaState = {
                            bigFace: angular.isDefined($(".bigFaceDetail").attr("style")) ? $(".bigFaceDetail").attr("style") : "",
                            supportcreation: angular.isDefined($(".bigFaceDetailRigth").attr("style")) ? $(".bigFaceDetailRigth").attr("style") : "",
                            ueditor: $(".bigFaceDetailLeft").attr("class")
                        };
                        $(".bigFaceDetail").attr("style", "");
                        $(".bigFaceDetailLeft").removeClass("col-sm-9").removeClass("col-md-9").removeClass("col-sm-8").addClass("col-md-6").addClass("col-sm-6");
                        $(".bigFaceDetailRigth").attr("style", "display:none");
                    }

                    $scope.close = function() {
                        if (angular.isFunction($scope.finishCallback)) $scope.finishCallback();
                        $scope.checkFinish = false;
                        $(".bigFaceDetail").attr("style", otherAreaState.bigFace);
                        $(".bigFaceDetailLeft").attr("class", otherAreaState.ueditor);
                        $(".bigFaceDetailRigth").attr("style", otherAreaState.supportcreation);
                        ue.fireEvent('contentchange'); //防止浏览器宽度恢复后高度不适
                    };
                }
            };
        }
    ]);
